// import 顺序 后覆盖前
import installElementUI from './lib/element-polyfill';
import {createApp} from 'vue';
import router from './router';
import store from './store';
import App from './App';
import './styles';
import installComponent from './components';
import '@/router.each';
import * as PageNames from '@/enmus/PageNames';

try {
    const app = createApp(App);
    app.config.globalProperties.$PageNames = PageNames;
    installElementUI(app);
    installComponent(app);
    app.use(router).use(store).mount('#app');
} catch (e) {
    console.error(e);
    window.showTips && window.showTips();
}
